module.exports = __webpack_public_path__ + "fonts/icon-font.5d87cf63ad677b70b8bcb19a9b5b94fb.woff2";